<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-center1"><a id="page_ii"><span class="small">ALSO BY DAVID WILLIAMS</span></a></p><a id="page_ii">
<p class="fm-center"><em class="italic">A People’s History of the Civil War: Struggles for the Meaning of Freedom</em></p>
<p class="fm-center"><em class="italic">Plain Folk in a Rich Man’s War: Class and Dissent in Confederate Georgia</em><br/>(with Teresa Crisp Williams and David Carlson)</p>
<p class="fm-center"><em class="italic">Johnny Reb’s War: Battlefield and Homefront</em></p>
<p class="fm-center"><em class="italic">Rich Man’s War: Class, Caste, and Confederate Defeat in the Lower<br/>Chattahoochee Valley</em></p>
<p class="fm-center"><em class="italic">The Georgia Gold Rush: Twenty-Niners, Cherokees, and Gold Fever</em></p>
<p class="fm-center"><em class="italic">Gold Fever: America’s First Gold Rush</em><br/>(with Ray C. Rensi)</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Frontmatter.vue?7846a837